export default __webpack_public_path__ + "static/spray-edge-2-bbffe920f15ce2c13436f069c93062fd.png";